<mat-form-field>
  <mat-label [translate]="label"> </mat-label>
  <input
    matInput
    [formControl]="control"
    name="password"
    [type]="getPasswordFieldType()"
    (focus)="onFocus()"
    [autocomplete]="autocomplete"
  />
  <mat-icon matSuffix (click)="toggleShowPassword()">
    {{ showPassword ? 'visibility' : 'visibility_off' }}
  </mat-icon>
  <mat-error>
    <gb-validation-messages [control]="control"></gb-validation-messages>
  </mat-error>
</mat-form-field>

<gb-password-hint
  *ngIf="showPasswordHint"
  [passwordComplexityPolicy$]="passwordComplexityPolicy$"
  [password]="control.value"
></gb-password-hint>
